<template>
  <header id="header" :class="navbarColor">
    <!--logo start-->
    <div :class="`brand ${navbarColor} hidden-sm-and-down`">
      <router-link
        :to="{ name: user ? 'home' : 'login' }"
        class="logo"
      >
        {{ appName }}
      </router-link>
    </div>
    <!--logo end-->
    <ul
      v-if="user"
      class="nav navbar-nav navbar-left"
    >
      <li class="toggle-navigation toggle-left">
        <button
          id="toggle-left"
          :class="`sidebar-toggle ${navbartoggleColor}`"
          @click="toggleSidebar"
        >
          <svg id ="hamButton" class="ham hamRotate ham7" viewBox="10 10 80 80" width="40">
            <path
                class="line top"
                d="m 70,33 h -40 c 0,0 -6,1.368796 -6,8.5 0,7.131204 6,8.5013 6,8.5013 l 20,-0.0013" />
            <path
                class="line middle"
                d="m 70,50 h -40" />
            <path
                class="line bottom"
                d="m 69.575405,67.073826 h -40 c -5.592752,0 -6.873604,-9.348582 1.371031,-9.348582 8.244634,0 19.053564,21.797129
                  19.053564,12.274756 l 0,-40" />
          </svg>
        </button>
      </li>
    </ul>
    <!-- <ul class="nav navbar-nav navbar-left">
          <li class="toggle-navigation toggle-left">
              <locale-dropdown />
          </li>
      </ul> -->
    <ul class="nav navbar-right">
      <!-- Authenticated -->
      <li
        v-if="user"
        class="dropdown profile hidden-xs"
      >
        <a
          :class="`nav-link dropdown-toggle sidebar-toggle ${navbartoggleColor}`"
          href="#"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <img
            :src="user.photo_url"
            class="rounded-circle profile-photo mr-1"
          >
          {{ user.name }}
        </a>
        <div class="dropdown-menu">
          <router-link
            :to="{ name: 'settings.profile' }"
            class="dropdown-item pl-3"
          >
          <v-chip
            color="success darken-1"
            dark
          >
          <fa
              icon="cog"
              fixed-width
            />
            {{ $t('profile') }}
          </v-chip>
          </router-link>

          <div class="dropdown-divider" />
          <a
            href="#"
            class="dropdown-item pl-3"
            @click.stop="dialog = true"
          >
            <v-chip
            color="red darken-1"
            dark
          >
            <fa
              icon="sign-out-alt"
              fixed-width
            />
            {{ $t('logout') }}
          </v-chip>
          </a>
        </div>
      </li>
    </ul>
    <ul class="nav navbar-left hidden-sm-and-down">
      <li
        v-if="user"
        class="dropdown profile hidden-xs"
      >
        <a
          :class="`nav-link dropdown-toggle sidebar-toggle ${navbartoggleColor}`"
          href="#"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <v-badge
              v-if="count_notify > 0"
              color="red"
              :content="count_notify"
            >
            <i class='fa fa-bell bell'/>
          </v-badge>
          <i v-else class='fa fa-bell'/>
        </a>
        <div class="dropdown-menu">
          <a
            class="dropdown-item pl-3"
          >
          <v-chip
            color="green"
            dark
            label
          >
          Tienes {{ this.count_notify }} {{ $t('notification') }}
          </v-chip>
          </a>

          <div class="dropdown-divider" />
          <router-link
            :to="{ name: 'notification' }"
            class="dropdown-item pl-3"
          >
          <v-chip
            color="red"
            dark
          >
            <v-icon small style="margin-right:3px">mdi-eye</v-icon>
            Ver más {{ $t('notification') }}
          </v-chip>
          </router-link>
        </div>
      </li>
    </ul>
    <v-dialog
      v-model="dialog"
      max-width="480"
    >
      <v-card>
        <v-card-title class="headline">
          ¿Está seguro que desea cerrar sesión?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click.prevent="logout"
          >
            Cerrar Sesión
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="150"
    >
      <template v-slot:activator="{ on, attrs }">
        <span :class="`fixed-button ${navbarColor}`" v-bind="attrs" v-on="on">
          <v-tooltip bottom>
            <template
              v-slot:activator="{ on }"
            >
              <v-icon v-on="on" class="theme-icon" color="white">mdi-palette-advanced</v-icon>
            </template>
            <span>Temas</span>
          </v-tooltip>
        </span>
      </template>
      <v-card>
        <div style="min-height: 110px">
          <v-row>
            <v-col cols="12" style="text-align: center;">Temas</v-col>
          </v-row>
          <v-row style="margin-left:20px !important">
            <v-btn
              class="theme-btn"
              x-small
              color="blue darken-1"
              @click="setTheme('blue')"
            ></v-btn>
            <v-btn
              class="theme-btn"
              x-small
              color="red darken-1"
              @click="setTheme('red')"
            ></v-btn>
            <v-btn
              class="theme-btn"
              x-small
              color="purple darken-1"
              @click="setTheme('purple')"
            ></v-btn>
            <v-btn
              class="theme-btn"
              x-small
              color="green darken-1"
              @click="setTheme('green')"
            ></v-btn>
          </v-row>
          <v-row style="margin-left:20px !important">
            <v-btn
              class="theme-btn"
              x-small
              color="orange darken-1"
              @click="setTheme('orange')"
            ></v-btn>
            <v-btn
              class="theme-btn"
              x-small
              color="pink lighten-1"
              @click="setTheme('fucsia')"
            ></v-btn>
            <v-btn
              class="theme-btn"
              x-small
              color="teal lighten-1"
              @click="setTheme('teal')"
            ></v-btn>
            <v-btn
              class="theme-btn"
              x-small
              color="light-blue lighten-1"
              @click="setTheme('lightblue')"
            ></v-btn>
          </v-row>
        </div>
      </v-card>
    </v-menu>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import i18n from '~/plugins/i18n';

export default {
  data: () => ({
    appName: window.config.appName,
    dialog: false,
    check: '',
    apiURL: 'api/notification/getNotificationCount',
    apiURLCheck: 'api/notification/checkNotification',
    menu: false,
  }),
  async mounted() {
    this.$nextTick(() => {
      window.setInterval(() => {
        this.checkTokenValidity();
      }, 60000);
    });
    if (this.user) {
      window.axios.get(`${this.apiURL}`)
      .then((response) => {
        this.count_notify = response.data;
      });

      window.axios.get(`${this.apiURLCheck}`)
      .then((response) => {
        this.check = response.data;
      });
    }
    if (this.navbarColor === undefined) {
      this.setTheme('blue');
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      token: 'auth/token',
      navbarColor: 'theme/navbarColor',
      navbartoggleColor: 'theme/navbartoggleColor',
    }),
    visible: {
      get() {
        return this.$store.state.sidebar.visible;
      },
      set(value) {
        this.$store.dispatch('sidebar/setSidebarVisible', { value });
      },
    },
    mini: {
      get() {
        return this.$store.state.sidebar.mini;
      },
      set(value) {
        this.$store.dispatch('sidebar/setSidebarMini', { value });
      },
    },
    count_notify: {
      get() {
        return this.$store.state.sidebar.count_notify;
      },
      set(value) {
        this.$store.dispatch('sidebar/setSidebarCountNotify', { value });
      },
    },
  },
  watch: {
    mini: {
      handler() {
        this.setHam();
      },
      deep: true,
    },
  },
  methods: {
    setHam() {
      const element = document.getElementById('hamButton');
      element.classList.toggle('active');
    },
    checkTokenValidity() {
      if (this.token) {
          const decodedToken = this.parseJwt(this.token);
          const novalido = (decodedToken.exp * 1000) - new Date().getTime() <= parseInt(process.env.VUE_APP_SESSION_TIME, 8);
          if (novalido) {
            Swal.fire({
              type: 'warning',
              title: i18n.t('token_almost_expired_alert_title'),
              text: i18n.t('token_almost_expired_alert_text'),
              reverseButtons: true,
              confirmButtonText: i18n.t('ok'),
              cancelButtonText: i18n.t('cancel'),
            });
          }
      }
      return false;
    },
    parseJwt(token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(window.atob(base64)
        .split('').map((c) => `%${ (`00${ c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));
      return JSON.parse(jsonPayload);
    },
    async logout() {
      this.dialog = false;
      await this.$store.dispatch('auth/logout');

      // Redirect to login.
      this.$router.push({ name: 'login' });
    },

    toggleSidebar() {
      this.visible = !this.visible;
      this.mini = !this.mini;
    },
    setTheme(color) {
      this.$store.dispatch('theme/setThemeColor', { value: color });
    },
  },
};
</script>

<style scoped>
.profile-photo {
  width: 2rem;
  height: 2rem;
  margin: -.375rem 0;
}

.navbar-right{
  margin-right: 60px;
  min-width: 130px;
}

.notification-dot {
  height: 9px;
  width: 9px;
  background-color: #c90b0b;
  border-radius: 50%;
  border: 1px solid white;
  display: inline-block;
  position: relative;
  top: -10px;
  left: -3px;
}
</style>
